import React from 'react';

const AnchorTag = (anchorTagProps: AnchorTagProps) => {
  if (!anchorTagProps) return null;

  const { anchorTag } = anchorTagProps;

  return <div id={anchorTag}></div>;
};

export type AnchorTagProps = {
  anchorTag: string;
} | null;

export default AnchorTag;
